module.exports = __webpack_public_path__ + "img/folder-icon.e7541171.svg";